import React, { useContext } from "react";
import { ErrorMessage } from "..";
import { MedicationAdministration } from "../../fhir";
import { Action } from "./actions";

export interface StateContext {
  medication: any;
  administration: MedicationAdministration;
  errors: ErrorMessage[];
}

export interface Store {
  globalState: StateContext;
  dispatch: React.Dispatch<Action>;
}

export const defaultState: StateContext = {
  medication: {},
  administration: {} as MedicationAdministration,
  errors: [] as ErrorMessage[]
};

export const AppContext = React.createContext<Store>({
  globalState: defaultState,
  dispatch: () => null,
});

export const useAdministrationStateContext = () => useContext(AppContext);
